import { render, staticRenderFns } from "./NewTagsView.vue?vue&type=template&id=55ecfa1d&"
import script from "./NewTagsView.vue?vue&type=script&lang=js&"
export * from "./NewTagsView.vue?vue&type=script&lang=js&"
import style0 from "./NewTagsView.vue?vue&type=style&index=0&id=55ecfa1d&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports